import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import Coolwhip from '../../Coolwhip/Coolwhip.es.js';
import { ModalContext } from '../Modal.Context/Modal.Context.es.js';

const ModalCoolwhip = ()=>{
    const { coolwhip } = useContext(ModalContext);
    if (!coolwhip) {
        // Hide without coolwhip props
        return null;
    }
    return jsx("div", {
        className: "cb-modal-coolwhip",
        children: jsx(Coolwhip, {
            ...coolwhip,
            "data-testid": "modal-coolwhip"
        })
    });
};
ModalCoolwhip.displayName = 'Modal.Coolwhip';

export { ModalCoolwhip };
//# sourceMappingURL=Modal.Coolwip.es.js.map
